// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Header component
 */
!(function () {
  "use strict";
  
  var React = require('react');
  var observer = require('mobx-react').observer;
  var Button = require('share/components/controls/Izenda.Button');
  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var Alert = require('share/components/controls/Izenda.Alert');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');

  var Header = React.createClass({
    propTypes: {
      disabled: React.PropTypes.bool.isRequired,
      onSave: React.PropTypes.func.isRequired,
      onCancel: React.PropTypes.func.isRequired,
      alertMessage : React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var alertMessage = props.alertMessage;
      
      return (
        <section className="izenda-Wrapper-header">
          
          <IconMenu />
          
          <Alert type={alertMessage.type} onAutoHide={props.onResetAlert}>
            {alertMessage.message}
          </Alert>
            
          <ActionBar 
            onSave={props.onSave}
            onCancel={props.onCancel}
            disabled={props.disabled} />
        </section>
      );
    }
  });

  module.exports = observer(Header);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/Header/Izenda.Header.jsx